interface Stat {
  value: string;
  label: string;
}

export default function Stats({ stats }: { stats: Stat[] }) {
  return (
    <section className="w-full py-16 md:py-20 px-4 md:px-6 bg-primary-500">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
          {stats.map((stat) => (
            <div key={stat.label} className="text-center">
              <div className="font-heading text-3xl md:text-4xl lg:text-5xl font-black text-white mb-2">
                {stat.value}
              </div>
              <div className="text-sm md:text-base text-white/75 font-medium">
                {stat.label}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}